/* =============================================================
   Acaure — Flujo de cierre del pedido (multi-paso → draft order)
   Reusa el carrito AJAX (window.AcaureShop). No manda precios de PRODUCTO
   (esos los pone Shopify por variant ID); el único monto que viaja es el
   costo de entrega configurado por el merchant en el editor de tema.
   ============================================================= */
(function () {
  "use strict";
  var root = document.querySelector("[data-acaure-cart]");
  if (!root) return;

  var ENDPOINT = (root.getAttribute("data-endpoint") || "").trim();
  var WA = (root.getAttribute("data-whatsapp") || "").trim();
  var CUSTOMER_ID = (root.getAttribute("data-customer-id") || "").trim();
  // Costo de entrega: fijo pero editable desde el editor de tema. Es la ÚNICA
  // excepción a "nunca mandar precios desde el cliente": este monto viaja al
  // endpoint y se agrega al draft order como línea custom "Entrega". Los
  // precios de PRODUCTO siguen saliendo solo de Shopify por variant ID.
  var DELIVERY_ON = (root.getAttribute("data-delivery-charge") || "").trim() === "true";
  var DELIVERY_COST = parseFloat(root.getAttribute("data-delivery-cost"));
  if (!isFinite(DELIVERY_COST) || DELIVERY_COST < 0) DELIVERY_COST = 0;
  var DELIVERY_CENTS = Math.round(DELIVERY_COST * 100);
  var DELIVERY_ACTIVE = DELIVERY_ON && DELIVERY_CENTS > 0;
  var ORDER = ["cart", "datos", "entrega", "pago", "revisar"];
  var lastCart = null;

  function $(s, ctx) { return (ctx || root).querySelector(s); }
  function $all(s, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(s)); }
  function val(sel) { var el = $(sel); return el ? el.value.trim() : ""; }
  function money(c) { return window.AcaureShop ? window.AcaureShop.formatMoney(c) : (c / 100).toFixed(2); }

  /* ---- WhatsApp en botones de fallback ---- */
  if (WA) $all("[data-wa]").forEach(function (a) { a.href = WA; });

  /* ---- Navegación de pasos ---- */
  function go(stage) {
    $all(".stage").forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-stage") === stage); });
    var idx = ORDER.indexOf(stage);
    $all("#stepsRail .step-cell").forEach(function (c) {
      var i = ORDER.indexOf(c.getAttribute("data-stage"));
      c.classList.toggle("is-current", i === idx);
      c.classList.toggle("is-done", i > -1 && idx > -1 && i < idx);
    });
    if (stage === "revisar") fillReview();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* ---- Render del carrito real ---- */
  function renderCart(cart) {
    lastCart = cart;
    var count = cart.item_count || 0;
    var label = count === 1 ? "1 paquete" : count + " paquetes";
    $all("[data-cart-count]").forEach(function (e) { e.textContent = label; });
    $all("[data-sum-count]").forEach(function (e) { e.textContent = label; });
    var subtotal = cart.total_price || 0;
    var delivery = (DELIVERY_ACTIVE && count > 0) ? DELIVERY_CENTS : 0;
    $all("[data-sum-subtotal]").forEach(function (e) { e.innerHTML = money(subtotal); });
    $all("[data-sum-delivery]").forEach(function (e) { e.innerHTML = money(delivery); });
    $all("[data-delivery-row]").forEach(function (e) { e.style.display = delivery > 0 ? "" : "none"; });
    $all("[data-sum-total]").forEach(function (e) { e.innerHTML = money(subtotal + delivery); });

    var box = $("[data-cart-lines]");
    if (box) {
      if (!count) {
        box.innerHTML = '<div class="cart-empty"><h3>Tu carrito está vacío</h3><p>Agrega algunos cortes para empezar.</p><a class="btn btn-azul" href="' + (root.getAttribute("data-shop-url") || "/collections/all") + '">Ir a la tienda</a></div>';
      } else {
        box.innerHTML = cart.items.map(function (it) {
          var thumb = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="">' : '<span class="ph">A</span>';
          var pack = (it.variant_title && it.variant_title !== "Default Title") ? '<p class="pack">' + it.variant_title + "</p>" : "";
          return '<div class="cart-line">' +
            '<div class="thumb">' + thumb + "</div>" +
            '<div class="meta"><h4>' + it.product_title + "</h4>" + pack +
              '<div class="qty">' +
                '<button data-cl-dec data-vid="' + it.variant_id + '" aria-label="Quitar uno">−</button>' +
                '<span class="val">' + it.quantity + "</span>" +
                '<button data-cl-inc data-vid="' + it.variant_id + '" aria-label="Agregar uno">+</button>' +
              "</div>" +
            "</div>" +
            '<div class="right"><span class="price">' + money(it.final_line_price) + "</span>" +
              '<button class="remove" data-cl-remove data-vid="' + it.variant_id + '">Quitar</button></div>' +
          "</div>";
        }).join("");
      }
    }
    // Deshabilitar continuar si no hay nada
    $all("[data-go]").forEach(function (b) { if (b.getAttribute("data-go") !== "cart") b.toggleAttribute("disabled", count === 0); });
  }

  document.addEventListener("acaure:cart:update", function (e) { renderCart(e.detail); });

  /* ---- Clicks ---- */
  root.addEventListener("click", function (e) {
    var goBtn = e.target.closest("[data-go]");
    var cell = e.target.closest(".step-cell");
    var inc = e.target.closest("[data-cl-inc]");
    var dec = e.target.closest("[data-cl-dec]");
    var rem = e.target.closest("[data-cl-remove]");
    var card = e.target.closest(".radio-card");
    var pedir = e.target.closest("[data-pedir]");

    if (goBtn) { e.preventDefault(); if (!goBtn.disabled) go(goBtn.getAttribute("data-go")); return; }
    if (cell) { go(cell.getAttribute("data-stage")); return; }
    if (inc || dec) {
      var b = inc || dec;
      var vid = Number(b.getAttribute("data-vid"));
      var cur = parseInt(b.parentNode.querySelector(".val").textContent, 10) || 1;
      if (window.AcaureShop) window.AcaureShop.setQty(vid, inc ? cur + 1 : cur - 1);
      return;
    }
    if (rem) { var v = Number(rem.getAttribute("data-vid")); if (window.AcaureShop) window.AcaureShop.setQty(v, 0); return; }
    if (card) {
      var group = card.closest("[data-radio-group]");
      if (group) { $all(".radio-card", group).forEach(function (c) { c.classList.remove("is-selected"); }); card.classList.add("is-selected"); }
      return;
    }
    if (pedir) { e.preventDefault(); submit(pedir); return; }
  });

  function selectedValue(groupSel) {
    var sel = $(groupSel + " .radio-card.is-selected");
    return sel ? (sel.getAttribute("data-value") || "") : "";
  }

  /* ---- Revisar ---- */
  function fillReview() {
    var set = function (sel, html) { var e = $(sel); if (e) e.innerHTML = html; };
    var revPhone = val("#f-phone") ? "+" + val("#f-cc") + " " + val("#f-phone") : "";
    set("[data-rev-datos]", esc(val("#f-name")) + "<br>" + esc(revPhone) + (val("#f-email") ? "<br>" + esc(val("#f-email")) : ""));
    var entrega = [val("#f-dir"), val("#f-zona")].filter(Boolean).join(" · ");
    var pref = selectedValue("[data-radio-group='entrega']");
    set("[data-rev-entrega]", esc(entrega || "—") + (pref ? "<br>" + esc(pref) : ""));
    set("[data-rev-pago]", esc(selectedValue("[data-radio-group='pago']") || "—"));
    if (lastCart) {
      set("[data-rev-items]", lastCart.items.map(function (i) { return esc(i.product_title) + (i.quantity > 1 ? " ×" + i.quantity : ""); }).join(" · "));
    }
  }
  function esc(s) { return (s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---- Error ---- */
  function showError(msg) {
    var box = $("[data-cart-error]");
    if (!box) return;
    box.innerHTML = msg + (WA ? ' <a href="' + WA + '" target="_blank" rel="noopener">Escríbenos por WhatsApp</a>.' : "");
    box.classList.add("is-visible");
  }
  function hideError() { var box = $("[data-cart-error]"); if (box) box.classList.remove("is-visible"); }

  /* ---- Teléfono: número local (el código de país va aparte, en #f-cc) ---- */
  // Devuelve el mensaje de error del número local, o null si es válido.
  // Cadena vacía = usar el mensaje por defecto (el que trae el HTML).
  // El cero troncal se rechaza para CUALQUIER país: Meta Cloud API exige el
  // número internacional sin el prefijo nacional 0.
  function phoneLocalError(s) {
    if (!/^[0-9\s\-]+$/.test(s)) return "";
    if (s.replace(/\D/g, "").charAt(0) === "0") return "Escribe tu número sin el 0 inicial";
    if (s.replace(/\D/g, "").length < 7) return "";
    return null;
  }
  var phoneErrDefault = "";
  function setPhoneError(on, text) {
    var input = $("#f-phone"), msg = $("[data-phone-error]");
    if (input) input.classList.toggle("is-error", on);
    if (msg) {
      if (!phoneErrDefault) phoneErrDefault = msg.textContent;
      if (on) msg.textContent = text || phoneErrDefault;
      msg.hidden = !on;
    }
  }

  /* ---- Enviar pedido ---- */
  function submit(btn) {
    hideError();
    var name = val("#f-name"), phone = val("#f-phone");
    if (!name || !phone) {
      showError("Necesitamos tu nombre y tu WhatsApp para cerrar el pedido.");
      go("datos");
      if (!name) $("#f-name").classList.add("is-error");
      if (!phone) $("#f-phone").classList.add("is-error");
      return;
    }
    var phoneMsg = phoneLocalError(phone);
    if (phoneMsg !== null) {
      go("datos");
      setPhoneError(true, phoneMsg);
      return;
    }
    if (!lastCart || !lastCart.items.length) { go("cart"); return; }
    if (!ENDPOINT) { showError("La tienda aún no tiene configurado el cierre de pedidos."); return; }

    var payload = {
      items: lastCart.items.map(function (i) { return { variantId: i.variant_id, quantity: i.quantity }; }),
      // Teléfono en dos campos: código de país (solo dígitos, del select) y
      // número local tal como lo escribió el cliente. El endpoint (Vercel) los
      // compone y valida; ya no viaja el campo único `phone`.
      customer: { name: name, phoneCountryCode: val("#f-cc").replace(/\D/g, ""), phoneLocal: phone, email: val("#f-email") },
      delivery: {
        zona: val("#f-zona"), referencia: val("#f-ref"), direccion: val("#f-dir"),
        preferencia: selectedValue("[data-radio-group='entrega']"), comentario: val("#f-com")
      },
      // Único precio que viaja desde el tema (el merchant lo fija en el editor).
      // El endpoint lo valida y lo agrega como línea custom "Entrega".
      deliveryFee: { charge: DELIVERY_ACTIVE, amount: DELIVERY_COST },
      payment: selectedValue("[data-radio-group='pago']")
    };
    if (CUSTOMER_ID) payload.customer.id = CUSTOMER_ID;

    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = "Enviando…";
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (res.ok && res.d && res.d.ok) {
          var folio = $("[data-aca-folio]");
          if (folio) folio.textContent = "Pedido #ACA-" + res.d.number;
          go("confirm");
          if (window.AcaureShop) {
            fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
              .then(function () { window.AcaureShop.refresh(); });
          }
        } else {
          throw new Error((res.d && res.d.error) || "error");
        }
      })
      .catch(function () {
        showError("No pudimos registrar tu pedido. Tu carrito sigue guardado.");
        btn.disabled = false; btn.textContent = orig;
      });
  }

  /* ---- Prefill (cliente logueado con metafields acaure_checkout) ---- */
  // El metafield whatsapp guarda el número COMPLETO (el endpoint escribe
  // "+58412…"; registros viejos pueden traer lo que tecleó el cliente).
  // Hay que repartirlo entre el select de país y el campo local.
  function prefillPhone(raw) {
    raw = (raw || "").trim();
    var sel = $("#f-cc"), input = $("#f-phone");
    if (!raw || !sel || !input) return;
    var digits = raw.replace(/\D/g, "");
    if (raw.charAt(0) === "+") {
      // Código de país = prefijo más largo que exista en el select (para "1"
      // ambiguo gana la primera opción del DOM: Estados Unidos, en prioridad).
      var codes = $all("option", sel)
        .map(function (o) { return o.value; })
        .sort(function (a, b) { return b.length - a.length; });
      for (var k = 0; k < codes.length; k++) {
        if (codes[k] && digits.indexOf(codes[k]) === 0) {
          sel.value = codes[k];
          // Sin cero troncal: datos viejos pueden traerlo y Meta Cloud API
          // exige el número internacional limpio (misma regla que valida el campo).
          input.value = digits.slice(codes[k].length).replace(/^0+/, "");
          return;
        }
      }
      input.value = raw; // sin match: se muestra crudo y la validación obliga a revisarlo
    } else if (digits.length === 12 && digits.indexOf("58") === 0) {
      sel.value = "58"; // formato viejo venezolano 58 + 10 dígitos sin "+"
      input.value = digits.slice(2).replace(/^0+/, "");
    } else {
      input.value = raw.replace(/^[0\s\-]+/, ""); // local tal cual, sin cero troncal (Venezuela por defecto)
    }
  }

  function prefillCustomer() {
    var fields = {
      "#f-name": "data-customer-nombre",
      "#f-email": "data-customer-email",
      "#f-zona": "data-customer-zona",
      "#f-ref": "data-customer-referencia",
      "#f-dir": "data-customer-direccion"
    };
    Object.keys(fields).forEach(function (sel) {
      var value = (root.getAttribute(fields[sel]) || "").trim();
      var el = $(sel);
      if (value && el) el.value = value;
    });
    prefillPhone(root.getAttribute("data-customer-whatsapp"));
  }

  /* ---- Init ---- */
  function init() {
    if (window.AcaureShop) window.AcaureShop.getCart().then(renderCart);
    prefillCustomer();
    // limpiar error de campos al escribir
    $all("#f-name, #f-phone").forEach(function (i) {
      i.addEventListener("input", function () {
        i.classList.remove("is-error");
        if (i.id === "f-phone") setPhoneError(false);
      });
    });
    // feedback temprano de formato al salir del campo (sin bloquear la navegación)
    var phoneInput = $("#f-phone");
    if (phoneInput) phoneInput.addEventListener("blur", function () {
      var v = phoneInput.value.trim();
      if (!v) return;
      var m = phoneLocalError(v);
      if (m !== null) setPhoneError(true, m);
    });
    // opción "Otro" en entrega despliega textarea
    var otro = $("[data-otro-field]");
    $all("[data-radio-group='entrega'] .radio-card").forEach(function (c) {
      c.addEventListener("click", function () { if (otro) otro.hidden = c.getAttribute("data-value") !== "Otro"; });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
